/** Preserve a trailing decimal so users can enter fractional values one character at a time. */
export const sanitizeDecimalInput = (raw: string): string => {
  const [whole, ...fractions] = raw.replace(/[^\d.]/g, '').split('.');

  return fractions.length > 0 ? `${whole}.${fractions.join('')}` : whole;
};
